import React from "react";

const AddRecipientModal = ({
  isModalAddRecipientOpen,
  handleCloseModal,
  selectedLanguage,
  DownloadReaderCSV,
  DownloadReaderXLS,
  ReadersfileSelectionClick,
  ReadersfileSelection,
  AddDragActive,
  ReadersinputFields,
  ReadersfileName,
  selectedFiles,
  fileNames,
  handleFileChange,
}) => {
  if (!isModalAddRecipientOpen) return null;

  return (
    <div
      className="modalCus"
      id="myModal"
      onRequestClose={handleCloseModal}
      shouldCloseOnOverlayClick={true}
      style={{ zIndex: 1075 }}>
      <div
        className="modal-dialog modal-dialog-centered custom-width-model"
        style={{ maxWidth: "955px", height: "40px" }}>
        <div className="modal-content">
          <div className="modal-header d-flex justify-content-right">
            <h4 className="mb-0 text-danger fw-bold font-20" htmlFor="">
              {selectedLanguage.LstLanguageCodes.UI_ImportReaders}
            </h4>

            <button
              type="button"
              className="btn btn-outline-danger Readerclose modalclose download "
              onClick={() => handleCloseModal()}>
              <span className="material-icons font-20">highlight_off</span>
            </button>
          </div>
          <div className="Mtop9 ">
            <span className="itemsalign">
              {
                selectedLanguage.LstLanguageCodes
                  .UI_PleaseDownloadTheXLSorCSV
              }{" "}
            </span>
            <span>
              <img
                src={"assets/img/icons/CSVdownload.png"}
                className="h-44p mleft15"
                alt="Download"
                onClick={(e) => DownloadReaderCSV()}
              />
            </span>
            <span>
              <img
                src={"assets/img/icons/XLSdownload.png"}
                className="h-44p "
                alt="Download"
                onClick={(e) => DownloadReaderXLS()}
              />
            </span>
          </div>
          <div className="col-sm-12 col-md-12 col-lg-5 dragdropwidth ps-2 pe-0 res-pe0">
            <div
              className={
                AddDragActive == true
                  ? "active-drop drag dragdropheight upload form-control ms-2 "
                  : "drag dragdropheight upload form-control ms-2 "
              }
              style={{ display: "grid" }}>
              <p className="d-flex flex-column justify-content-center font-w600 font-14 mb-0">
                <div className="row row-height">
                  <div
                    className={
                      ReadersinputFields.length > 0
                        ? "d-flex flex-column align-items-center justify-content-center col-md-5 ps-1 pe-2"
                        : "d-flex flex-column align-items-center justify-content-center col-md-12 ps-1 pe-2 pt-12Moz"
                    }>
                    <input
                      type="file"
                      multiple
                      id="imgFileReaders"
                      title={ReadersfileName}
                      onClick={(e) => ReadersfileSelectionClick(e)}
                      onChange={(e) => ReadersfileSelection(e)}></input>
                    <span className="pb-1 pt-1 light">
                      {
                        selectedLanguage.LstLanguageCodes
                          .UI_DragandDropfilesHere
                      }
                    </span>
                    <span className="pb-1">
                      {selectedLanguage.LstLanguageCodes.UI_or}
                    </span>
                    <span className="light underline">
                      {" "}
                      {
                        selectedLanguage.LstLanguageCodes
                          .UI_ClickAndSelectFiles
                      }
                    </span>
                  </div>
                  <div
                    className={
                      ReadersinputFields.length > 0
                        ? "col-md-7 col-sm-12 ps-1 pe-2"
                        : "col-md-7 col-sm-12 ps-1 pe-2 d-none"
                    }
                    style={{
                      borderLeft: "2px dashed rgb(67 94 190 / 50%)",
                    }}>
                    <div className="file-scrollbar d-none d-md-block">
                      {ReadersinputFields.map((data, index) => {
                        return (
                          <aside
                            className="d-flex align-items-center row mt-1 pb-1 w-100"
                            style={{ marginLeft: "0px" }}
                            draggable
                            // onDragStart={(e) => dragStart(e, index)}
                            // onDragOver={(e) => dragOver(e, index)}
                            // onDrop={(e) => dragDrop(e, index)}
                            key={index}>
                            <div
                              className={
                                data.edit == true
                                  ? "d-flex align-items-center box-width col-sm-10 ps-0"
                                  : "d-flex align-items-center  box-width col-sm-8 ps-0"
                              }>
                              {/* <span className="material-icons font-20">
                                  task
                                </span> */}
                              {data.edit == false && (
                                <span
                                  className="ms-1 font-14 font-w400 filename-text"
                                  title={data.orgFileName}>
                                  {data.mdfFileName + data.fileFormat}
                                </span>
                              )}
                              {data.edit == true && (
                                <>
                                  <input
                                    className="border-r4 edit-box"
                                    type="text"
                                    placeholder={
                                      selectedLanguage.LstLanguageCodes
                                        .UI_EnterFilename
                                    }
                                    value={data.mdfFileName}
                                    onDragStart={(e) => {
                                      e.preventDefault();
                                    }}
                                  // onChange={(event) =>
                                  //   fileNameChange(
                                  //     data.indexVal,
                                  //     event.target.value
                                  //   )
                                  // }
                                  ></input>
                                  {/* {data.fileFormat} */}
                                </>
                              )}
                            </div>
                          </aside>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </p>
            </div>

            <div className="row mt-3 d-flex align-items-center w-100"></div>
          </div>
          {selectedFiles.length > 0 && (
            <span className="ReadersFileName ms-4 ps-2" title={fileNames}>
              {selectedLanguage.LstLanguageCodes.UI_FileName}: {fileNames}
            </span>
          )}
          <div style={{ paddingBottom: "10px" }}>
            {/* <input type="button" className="UploadReaders btn btn-primary" onClick={handleUpload} value="Upload"></input> */}
            <button
              type="button"
              onClick={() => {
                handleFileChange();
              }}
              disabled={!selectedFiles || selectedFiles.length === 0}
              className="btn btn-primary UploadReaders">
              {selectedLanguage.LstLanguageCodes.UI_Upload}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddRecipientModal;
